import { ReactNode } from "react";
import { Controller, Control, FieldValues, Path } from "react-hook-form";

import { DatePicker, DatePickerProps } from "src/components/DatePicker";

export type { DatePickerProps };
export { DatePicker };

// ============= RHF Field =============

export interface DatePickerFieldProps<TForm extends FieldValues> {
  name: Path<TForm>;
  control: Control<TForm, any, any>;
  label: string;
  disableFuture?: boolean;
  disabled?: boolean;
  clearable?: boolean;
}

export const DatePickerField = <TForm extends FieldValues>({
  name,
  control,
  label,
  disableFuture,
  disabled,
  clearable,
}: DatePickerFieldProps<TForm>): ReactNode => (
  <Controller
    name={name}
    control={control}
    render={({ field, fieldState }) => (
      <DatePicker
        label={label}
        value={field.value ?? null}
        onChange={field.onChange}
        onBlur={field.onBlur}
        error={fieldState.error?.message}
        disableFuture={disableFuture}
        disabled={disabled}
        clearable={clearable}
      />
    )}
  />
);
